export default __webpack_public_path__ + "static/media/icon-balanco-medicamento.a32ba0fa.svg";